export const questions = [
    {
      questionText: "“Termodinamika va issiqlik uzatish asoslari” fani nimani o‘rgatadi?",
      answerOptions: [
        { id: 1, answerText: "Termodinamika va issiq’lik  uzatish  fani icciklikni ishlab chikarish nazariy acoclarini o‘rganuvchi fan", isCorrect: false },
        { id: 2, answerText: "Termodinamika va issiq’lik  uzatish  fani icciklikdan foydalanib kishlok xo‘jalik maxculotlarini etishtirishni o‘rganuvchi fan", isCorrect: false },
        { id: 3, answerText: "Issiqlik mashinalari va qurilmalari yordamida issiqlik hosil qilish, uni boshqa turdagi energiyaga aylantirish, taqsimlash hamda uzatish usullarini nazariy va amaliy jihatdan qamrab olgan umumtexnikaviy fandir", isCorrect: true, },
        { id: 4, answerText: "Termodinamika va issiq’lik  uzatish   fani quyosh energiyasi, gidroenergiya, turli yonilgilardan xocil bo‘ladigan energiyalarni o‘rganuvchi fan", isCorrect: false },
      ],
    },
    {
      questionText: "Termodinamik sistema nima?",
      answerOptions: [
        { id: 1, answerText: "Har qanday real modda ", isCorrect: false },
        { id: 2, answerText: "О‘zaro tashqi muhitsiz energiya almasha oladigan zarralar oqimi", isCorrect: false },
        { id: 3, answerText: "Tashqi muhit bilan o‘zaro aloqaga bulib, energiya va modda almashadigan jismlar majmui", isCorrect: true, },
        { id: 4, answerText: "Gaz xolati ", isCorrect: false },
      ],
    },
    {
      questionText: "Termadinamikaning 1 chi qonunini matematik ifodasi",
      answerOptions: [
        { id: 1, answerText: "dQ/dV", isCorrect: false },
        { id: 2, answerText: "dQ=dU+dA", isCorrect: true },
        { id: 3, answerText: "dQ=P*dV", isCorrect: false, },
        { id: 4, answerText: "dQ=PV*RT", isCorrect: false },
      ],
    },
    {
      questionText: "Sistemaning issiqlik holatini tasvirlaydigan asosiy holat parametrlaridan biri.",
      answerOptions: [
        { id: 1, answerText: "Politrop jarayoni", isCorrect: false },
        { id: 2, answerText: "Izobarik jarayoni", isCorrect: false },
        { id: 3, answerText: "Izotermik jarayoni", isCorrect: false, },
        { id: 4, answerText: "Harorat", isCorrect: true },
      ],
    },
    {
      questionText: "Issiqlik mashinasi nima?",
      answerOptions: [
        { id: 1, answerText: "Transport vositasi", isCorrect: false },
        { id: 2, answerText: "issiqliq energiyasini mexanik energiyaga aylantirib beradi", isCorrect: true },
        { id: 3, answerText: "Suyuqlik  energiyasini elektr energiyaga aylantirib beradi", isCorrect: false, },
        { id: 4, answerText: "Elektrodvigatel ", isCorrect: false },
      ],
    },
    {
      questionText: "Sistemaning o‘zgarmas solishtirma hajmi V=const da yuz beradigan termodinamik hodisalar majmuiga  deyiladi",
      answerOptions: [
        { id: 1, answerText: "Izotermik jarayoni", isCorrect: false },
        { id: 2, answerText: "Izobarik jarayoni.", isCorrect: false },
        { id: 3, answerText: "Izoxоrik jarayoni", isCorrect: true, },
        { id: 4, answerText: "Adiadatik jarayoni", isCorrect: false },
      ],
    },
    {
      questionText: "O‘zgarmas bosim ostida kechadigan termodinamik hodisalar majmui ……… deyiladi.  ",
      answerOptions: [
        { id: 1, answerText: "Izobarik jarayoni", isCorrect: true },
        { id: 2, answerText: "Izotermik jarayoni", isCorrect: false },
        { id: 3, answerText: "Politrop jarayoni", isCorrect: false, },
        { id: 4, answerText: "Adiadatik", isCorrect: false },
      ],
    },
    {
      questionText: "O‘zgarmas haroratda sodir bo‘ladigan termodinamik jarayon ………. deyiladi.",
      answerOptions: [
        { id: 1, answerText: "Izobarik jarayoni", isCorrect: false },
        { id: 2, answerText: "izotermik jarayoni", isCorrect: true },
        { id: 3, answerText: "Politrop jarayoni", isCorrect: false, },
        { id: 4, answerText: "Adiadatik jarayoni", isCorrect: false },
      ],
    },
    {
      questionText: "Tabiiy yoqilg‘i deb nimaga aytiladi?",
      answerOptions: [
        { id: 1, answerText: "Yoqilg‘ining o‘txonga qaysi holda berilsa, bu yoqilg‘iga", isCorrect: false },
        { id: 2, answerText: "Issiqlik ajratish xususiyati 2,93*104 kj/kg yoki 3*104 kj/kg bo‘gan yoqilg‘iga", isCorrect: false },
        { id: 3, answerText: "Tabiatdan olib, unga turli usullar bilan ishlov berilgandan so‘ng olingan yoqilg‘iga", isCorrect: false, },
        { id: 4, answerText: "tabiatda qanday hosil bo‘lgan bo‘lsa, shundayligicha olinadigan yoqilg‘iga", isCorrect: true },
      ],
    },
    {
      questionText: "Qozon qurilmasi deb nimaga aytiladi?",
      answerOptions: [
        { id: 1, answerText: "Qozon agregati va yordamchi uskunalar majmuasiga", isCorrect: false },
        { id: 2, answerText: "tutun-gaz aralashmalari issiqligidan foydalanib ishlaydigan qurilmalar majmuasiga", isCorrect: true },
        { id: 3, answerText: "Bosim ostida issiq suv va bug‘ hosil bo‘ladigan uskunalar majmuasiga", isCorrect: false, },
        { id: 4, answerText: "Bug‘ turbinalari uchun bug‘ yetkazib beruvchi", isCorrect: false },
      ],
    },
    {
      questionText: "Gaz turbinlarida yonish mahsuli nima hisoblanadi?",
      answerOptions: [
        { id: 1, answerText: "Solyarka", isCorrect: false },
        { id: 2, answerText: "Neft", isCorrect: false },
        { id: 3, answerText: "Gaz ", isCorrect: false, },
        { id: 4, answerText: "tutun", isCorrect: true },
      ],
    },
    {
      questionText: "Gaz turbinalari 30 yillarda qaysi sohada keng qullana boshlanadi?",
      answerOptions: [
        { id: 1, answerText: "kemasozlik, kimyosanoati, aviatsiya", isCorrect: true },
        { id: 2, answerText: "Kemasozlik, avtomobilsozlik", isCorrect: false },
        { id: 3, answerText: "Kimyosanoati, metalsanoati ", isCorrect: false, },
        { id: 4, answerText: "Aviatsiya, qurilish soxada", isCorrect: false },
      ],
    },
    {
      questionText: "12	Reaktiv dvigatel necha xil bo‘ladi?",
      answerOptions: [
        { id: 1, answerText: "Havo  reaktiv va reaktiv dvigatel", isCorrect: false },
        { id: 2, answerText: "Raketa va kimyoviy dvigatel", isCorrect: false },
        { id: 3, answerText: "turbo reaktiv va pulsatsiyali dvigatel", isCorrect: true, },
        { id: 4, answerText: "Pulsatsiyali  dvigatel", isCorrect: false },
      ],
    },
    {
      questionText: "Bosim deb nimaga aytiladi?",
      answerOptions: [
        { id: 1, answerText: "Mutloq bosimga", isCorrect: false },
        { id: 2, answerText: "1m² yuzaga normal tasir etuvchi kuch", isCorrect: true },
        { id: 3, answerText: "Аtmosfera bosimga", isCorrect: false, },
        { id: 4, answerText: "Оrtiqcha bosimga", isCorrect: false },
      ],
    },
    {
      questionText: "14	Atmosfera havosini necha xil usulda siqish mumkin?",
      answerOptions: [
        { id: 1, answerText: "1 usulda", isCorrect: false },
        { id: 2, answerText: "2 usulda", isCorrect: false },
        { id: 3, answerText: "3 usulda", isCorrect: false, },
        { id: 4, answerText: "4 usulda ", isCorrect: true },
      ],
    },
    {
      questionText: "Qaysi ifoda izxorik jarayonga mos keladi  ",
      answerOptions: [
        { id: 1, answerText: "v = соnst ", isCorrect: true },
        { id: 2, answerText: "Т= соnst", isCorrect: false },
        { id: 3, answerText: "PVᵏ=const", isCorrect: false, },
        { id: 4, answerText: "PVⁿ=const", isCorrect: false },
      ],
    },
    {
      questionText: "Qasi jarayonda q = 0:",
      answerOptions: [
        { id: 1, answerText: "Izotermik ", isCorrect: false },
        { id: 2, answerText: "аdiabatik", isCorrect: true },
        { id: 3, answerText: "Izobarik ", isCorrect: false, },
        { id: 4, answerText: "Izoxor ", isCorrect: false },
      ],
    },
    {
      questionText: "Issiqlik nasoslari qachon ishlatiladi?",
      answerOptions: [
        { id: 1, answerText: "gidro energiya yetishmaganda", isCorrect: true },
        { id: 2, answerText: "Ortiqcha  yoqilg‘i bo‘lganda", isCorrect: false },
        { id: 3, answerText: "Yoqilg‘i  yetishmaganda", isCorrect: false, },
        { id: 4, answerText: "Ortiqcha  gidroen ergiyabo‘lganda", isCorrect: false },
      ],
    },
    {
      questionText: "Karno sikli qanday jarayonlardan tashkil topgan:",
      answerOptions: [
        { id: 1, answerText: "1ta izobara va 2 ta politropik jarayonlaridan", isCorrect: false },
        { id: 2, answerText: "1 ta izoxora va 2 ta izobara jarayonlaridan", isCorrect: false },
        { id: 3, answerText: "2 ta izoterma va 2 ta adiabata jarayonlaridan", isCorrect: true, },
        { id: 4, answerText: "1 ta izobara va 1ta izoterma jarayonlaridan", isCorrect: false },
      ],
    },
    {
      questionText: "Gaz turbinaning dvigateliga nimalar kiradi?",
      answerOptions: [
        { id: 1, answerText: "Gazlash  sistemasi", isCorrect: false },
        { id: 2, answerText: "Suv  bilan ta’minlash", isCorrect: false },
        { id: 3, answerText: "Nasoslar, havo sovutkich", isCorrect: false, },
        { id: 4, answerText: "Moy sistemasi, nasoslar", isCorrect: true },
      ],
    },
    {
      questionText: "Xarorat deganda nimani tuchunaciz?",
      answerOptions: [
        { id: 1, answerText: "Xarorat  jicmning qizish xicobiga ish bajarish darajacini ko‘rcatadi", isCorrect: false },
        { id: 2, answerText: "Xarorat zapac imkoniyat, lekin xali bajarilmagan ishdir", isCorrect: false },
        { id: 3, answerText: "Xarorat jicmning qizitilganlik darajasini ifodalaydi", isCorrect: true, },
        { id: 4, answerText: "Xarorat  jicmning energiya  zonacini ko‘rcatadi", isCorrect: false },
      ],
    },
    {
      questionText: "Adiabatik jarayon deb nimaga aytiladi?",
      answerOptions: [
        { id: 1, answerText: "issiqliq almashmasdan kechuvchi jarayon", isCorrect: true },
        { id: 2, answerText: "Doimiy  hajmda kechuvchi jarayon", isCorrect: false },
        { id: 3, answerText: "Doimiy  haroratda kechuvchi jarayon", isCorrect: false, },
        { id: 4, answerText: "Doimiy  bosim ostida kechuvchi jarayon", isCorrect: false },
      ],
    },
    {
      questionText: "Atom elektr stantsiyalari qanday vazifani bajaradi?",
      answerOptions: [
        { id: 1, answerText: "Chillaki va Gerbosh uzum navlaridan dorilanmay oftobda quritiladi.", isCorrect: false },
        { id: 2, answerText: "atom (yadro) energiyasini elektr energiyaga aylantiradi", isCorrect: true },
        { id: 3, answerText: "Mexanik  energiyani issiqlik energiyasiga aylantiradi", isCorrect: false, },
        { id: 4, answerText: "Elektr  energiyasini mexanik energiyaga aylantiradi", isCorrect: false },
      ],
    },
    {
      questionText: "Bosim qaysi formula bilan ifodalanadi?",
      answerOptions: [
        { id: 1, answerText: "P=F/S", isCorrect: true },
        { id: 2, answerText: "D=R/2", isCorrect: false },
        { id: 3, answerText: "V=S/t", isCorrect: false, },
        { id: 4, answerText: "π=3.14", isCorrect: false },
      ],
    },
    {
      questionText: "Bosimning SI sistemadagi o‘lchov birligini aniqlang?",
      answerOptions: [
        { id: 1, answerText: "kg/m", isCorrect: false },
        { id: 2, answerText: "kg", isCorrect: false },
        { id: 3, answerText: "kg/sm", isCorrect: false, },
        { id: 4, answerText: "Pa", isCorrect: true },
      ],
    },
    {
      questionText: "Bug‘ qozon qurilmasi qanday yoqilgida ishlaydi?",
      answerOptions: [
        { id: 1, answerText: "benzin", isCorrect: false },
        { id: 2, answerText: "dizel yokilgisi", isCorrect: false },
        { id: 3, answerText: "toshkumir, torf, neft ", isCorrect: true, },
        { id: 4, answerText: "torf", isCorrect: false },
      ],
    },
    {
      questionText: "Bug‘ turbinalarida bug‘ning bosimi qancha bo‘ladi?",
      answerOptions: [
        { id: 1, answerText: "5-10 mPa", isCorrect: false },
        { id: 2, answerText: "10-15 mPa", isCorrect: false },
        { id: 3, answerText: "23-25 mPa", isCorrect: true, },
        { id: 4, answerText: "0-20 mPa", isCorrect: false },
      ],
    },
    {
      questionText: "Bug‘ turbinalarida Bug‘ning harorati necha gradusni",
      answerOptions: [
        { id: 1, answerText: "60-80k", isCorrect: false },
        { id: 2, answerText: "700-800 k ", isCorrect: true },
        { id: 3, answerText: "200-400 k", isCorrect: false, },
        { id: 4, answerText: "120-140 k", isCorrect: false },
      ],
    },
    {
      questionText: "Bug‘ turbinalarining ish jismi nimadan iborat?",
      answerOptions: [
        { id: 1, answerText: "Havo", isCorrect: false },
        { id: 2, answerText: "Gaz ", isCorrect: false },
        { id: 3, answerText: "Suv ", isCorrect: false, },
        { id: 4, answerText: "qizdirilgan suv bug‘i", isCorrect: true },
      ],
    },
    {
      questionText: "Bug‘ turbinasining asosiy parametrlari nima?",
      answerOptions: [
        { id: 1, answerText: "bosim", isCorrect: false },
        { id: 2, answerText: "bosim va temperatura", isCorrect: true },
        { id: 3, answerText: "hajm", isCorrect: false, },
        { id: 4, answerText: "temperatura", isCorrect: false },
      ],
    },
    {
      questionText: "Bug‘-qozon qurilmasining asosiy mahsuloti nimadan iborat?",
      answerOptions: [
        { id: 1, answerText: "Gaz ", isCorrect: false },
        { id: 2, answerText: "Elektr energiyasi", isCorrect: false },
        { id: 3, answerText: "issiq suv, suv bug‘i", isCorrect: true, },
        { id: 4, answerText: "Issiq havo", isCorrect: false },
      ],
    },
    {
      questionText: "Buglanish deb nimaga aytiladi?",
      answerOptions: [
        { id: 1, answerText: "suyuklikni suyuk xolatidan bug xolatiga utishi", isCorrect: true },
        { id: 2, answerText: "Suyuklikni  cuyuk xolati muzlashi", isCorrect: false },
        { id: 3, answerText: "Suyuklikni  cuyuk xolatidan qaytishi", isCorrect: false, },
        { id: 4, answerText: "Suyuqlikning  xarorati o‘zgarishi", isCorrect: false },
      ],
    },
    {
      questionText: "Gaz  turbinalari  qaerlarda ishlatiladi?",
      answerOptions: [
        { id: 1, answerText: "Elektr stantsiyalarida", isCorrect: false },
        { id: 2, answerText: "Kema  va samolyot dvigatellarida", isCorrect: true },
        { id: 3, answerText: "maxsus quritish qurilmasida quritish usuli", isCorrect: false, },
        { id: 4, answerText: "IYOD da", isCorrect: false },
      ],
    },
    {
      questionText: "Gaz turbinalari quvvatining o‘lchov birligi nima?",
      answerOptions: [
        { id: 1, answerText: "kvt/s", isCorrect: false },
        { id: 2, answerText: "j", isCorrect: false },
        { id: 3, answerText: "n", isCorrect: false, },
        { id: 4, answerText: "kVt", isCorrect: true },
      ],
    },
    {
      questionText: "Gelioelektr stantsiyalarining ish jismi nima?",
      answerOptions: [
        { id: 1, answerText: "Gaz ", isCorrect: false },
        { id: 2, answerText: "quyosh energiyasi", isCorrect: true },
        { id: 3, answerText: "Qattiq  yoqilgi", isCorrect: false, },
        { id: 4, answerText: "Suyuq  yoqilg‘i", isCorrect: false },
      ],
    },
    {
      questionText: "Gaz turbinalarining asosiy ish jismi nima?",
      answerOptions: [
        { id: 1, answerText: "Havo ", isCorrect: false },
        { id: 2, answerText: "Suv bug‘i ", isCorrect: false },
        { id: 3, answerText: "Kislorod ", isCorrect: false, },
        { id: 4, answerText: "qizdirilgan gaz", isCorrect: true },
      ],
    },
    {
      questionText: "GES larda bug‘ning bosimi qancha bo‘ladi?",
      answerOptions: [
        { id: 1, answerText: "22-25 mPa", isCorrect: true },
        { id: 2, answerText: "0-10 mPa", isCorrect: false },
        { id: 3, answerText: "5-10 mPa", isCorrect: false, },
        { id: 4, answerText: "15-20 mPa", isCorrect: false },
      ],
    },
    {
      questionText: "Yoqilg‘ining tarkibiy qismi nimadan iborat?",
      answerOptions: [
        { id: 1, answerText: "vodorod (H₂)", isCorrect: false },
        { id: 2, answerText: "kislorod (O₂)", isCorrect: false },
        { id: 3, answerText: "uglerod (C)", isCorrect: true, },
        { id: 4, answerText: "azot(N₂)", isCorrect: false },
      ],
    },
    {
      questionText: "Jismning temperaturasi qaysi o‘lchov birligida ifodalanadi?",
      answerOptions: [
        { id: 1, answerText: "⁰C", isCorrect: false },
        { id: 2, answerText: "m", isCorrect: true },
        { id: 3, answerText: "kg", isCorrect: false, },
        { id: 4, answerText: "soat", isCorrect: false },
      ],
    },
    {
      questionText: "Jismning temperaturasi nimani bildiradi?",
      answerOptions: [
        { id: 1, answerText: "jismning isiganlik darajasi", isCorrect: true },
        { id: 2, answerText: "Jismning  og‘irligini", isCorrect: false },
        { id: 3, answerText: "Qarshilik  kuchi", isCorrect: false, },
        { id: 4, answerText: "Jismning  hajmini", isCorrect: false },
      ],
    },

    {
      questionText: "Issiqlik miqdorining o‘lchov birligi nima?",
      answerOptions: [
        { id: 1, answerText: "kg/s ", isCorrect: false },
        { id: 2, answerText: "vt/s", isCorrect: false },
        { id: 3, answerText: "j", isCorrect: true, },
        { id: 4, answerText: "j/s", isCorrect: false },
      ],
    },
    {
      questionText: "Issiqlik nima?",
      answerOptions: [
        { id: 1, answerText: "atom va molekulalarning murakkab harakati natijasida paydo buluvchi energiya", isCorrect: true },
        { id: 2, answerText: "Molekula ", isCorrect: false },
        { id: 3, answerText: "Ichki  yonuv dvigateli", isCorrect: false, },
        { id: 4, answerText: "Xarakatlantiruvchi  kuch", isCorrect: false },
      ],
    },
    {
      questionText: "Issiqlik oqimining quvvati qaysi o‘lchov birligida o‘lchanadi?",
      answerOptions: [
        { id: 1, answerText: "sek/s", isCorrect: false },
        { id: 2, answerText: "Vt", isCorrect: true },
        { id: 3, answerText: "kg/s", isCorrect: false, },
        { id: 4, answerText: "j/s", isCorrect: false },
      ],
    },
    {
      questionText: "Ichki yonuv dvigatellarida qanday yonilg‘i ishlatiladi.",
      answerOptions: [
        { id: 1, answerText: "Plazma ", isCorrect: false },
        { id: 2, answerText: "Qattik  yonilg‘i", isCorrect: false },
        { id: 3, answerText: "Vodorod ", isCorrect: false, },
        { id: 4, answerText: "suyuk yonilg‘i", isCorrect: true },
      ],
    },
    {
      questionText: "Ish jismiga nimalar kiradi?",
      answerOptions: [
        { id: 1, answerText: "Tok kuchi ", isCorrect: false },
        { id: 2, answerText: "benzin, kerosin, mazut, gaz va kumir", isCorrect: true },
        { id: 3, answerText: "Havo ", isCorrect: false, },
        { id: 4, answerText: "Suv ", isCorrect: false },
      ],
    },
    {
      questionText: "Solishtirma hajm o’lchov birligi ",
      answerOptions: [
        { id: 1, answerText: "m³/kg ", isCorrect: false },
        { id: 2, answerText: "kg ", isCorrect: false },
        { id: 3, answerText: "m³ ", isCorrect: false, },
        { id: 4, answerText: "mPa", isCorrect: true },
      ],
    },
    {
      questionText: "Termodinamikaning  birinchi qonuni nimani   ifodalaydi?",
      answerOptions: [
        { id: 1, answerText: "sistemaga uzatilgan issiqlik miqdorining bajargan ishini", isCorrect: true },
        { id: 2, answerText: "Issiqlik  miqdori", isCorrect: false },
        { id: 3, answerText: "Issiqlik  sig‘imi", isCorrect: false, },
        { id: 4, answerText: "Moddaning  hajmi", isCorrect: false },
      ],
    },
    {
      questionText: "Termodinamikaning birinchi qonunining   matematik   ifodasini  ko‘rsating",
      answerOptions: [
        { id: 1, answerText: "dA=Pdt", isCorrect: false },
        { id: 2, answerText: "ds=dq/T", isCorrect: false },
        { id: 3, answerText: "△q=du+A", isCorrect: true, },
        { id: 4, answerText: "△S=S", isCorrect: false },
      ],
    },
    {
      questionText: "Termodinamikaning ikkinchi qonuni nimani ta’riflaydi.",
      answerOptions: [
        { id: 1, answerText: "Energiyaning  saqlanish qonuni.", isCorrect: false },
        { id: 2, answerText: "issiqlik energiyasining to’liiq ishga aylanmasligi va issiqlik sovuq sistemadan issiq sistemaga o‘z-o‘zidan o‘ta olmasligi", isCorrect: true },
        { id: 3, answerText: "Energiyaning  bir turdan ikkinchi turga aylanishi", isCorrect: false, },
        { id: 4, answerText: "Sistemaning  issiqlik sig‘imi", isCorrect: false },
      ],
    },
    {
      questionText: "Selsiy shkalasidan Kelvin shkalasiga kanday munosabat orqali utiladi?",
      answerOptions: [
        { id: 1, answerText: "T=t⁰+273,15", isCorrect: true },
        { id: 2, answerText: "P=F/S", isCorrect: false },
        { id: 3, answerText: "T=2/3*U/K", isCorrect: false, },
        { id: 4, answerText: "PV/T=RN", isCorrect: false },
      ],
    },
  ]